import { render } from "./category.vue?vue&type=template&id=a7510b5c"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
script.render = render

export default script